export default __webpack_public_path__ + "static/sydework-c6b8a6220d8d1114366d603444a495d3.png";